import { useReportForm } from 'modules/reports/hooks/useReportFormContext';
import NextStepButton from '../../components/atoms/next-step-button/NextStepButton';
import { DatePicker } from '@sanlam-glacier/app-common/components';
import { SelectReportOptions } from './SelectReportOptions';
import { ClientChips } from '../../components/atoms/client-chip/ClientChips';
import styles from './report-period.module.scss';

export const ReportPeriod = () => {
  const { formData, updateFormData } = useReportForm();

  return (
    <div>
      <h2>Selected Clients:</h2>
      <ClientChips />

      <h2>Select Report Period</h2>
      <div className={styles.datePickerContainer}>
        <DatePicker
          className=''
          closeOnScroll
          shouldCloseOnSelect
          variant={DatePicker.VARIANT.DEFAULT}
          date={
            Array.isArray(formData.period.start) ? formData.period.start[0] : formData.period.start
          }
          onChange={(date) =>
            updateFormData({
              period: { ...formData.period, start: date }
            })
          }
        />

        <p>To</p>

        <DatePicker
          closeOnScroll
          shouldCloseOnSelect
          variant={DatePicker.VARIANT.DEFAULT}
          date={Array.isArray(formData.period.end) ? formData.period.end[0] : formData.period.end}
          onChange={(date) =>
            updateFormData({
              period: { ...formData.period, end: date }
            })
          }
        />
      </div>

      <SelectReportOptions />

      <NextStepButton />
    </div>
  );
};
